<ng-container [ngSwitch]="type">
  <div popper [validate]="formControl">
    <ng-container *ngSwitchCase="'text'">
      <input type="text"
             autocomplete="off"
             class="form-control"
             [name]="name"
             [placeholder]="placeholder"
             [disabled]="disabled"
             [attr.type]="inputType"
             [ngModel]="value"
             (ngModelChange)="change($event)">
    </ng-container>

    <ng-container *ngSwitchCase="'checkbox'">
      <check-input [name]="name"
                   [disabled]="disabled"
                   [ngModel]="value"
                   (ngModelChange)="change($event)">
        <ng-content></ng-content>
      </check-input>
    </ng-container>

    <ng-container *ngSwitchCase="'textarea'">
      <textarea rows="5"
                class="form-control"
                [name]="name"
                [placeholder]="placeholder"
                [disabled]="disabled"
                [ngModel]="value"
                (ngModelChange)="change($event)">
      </textarea>
    </ng-container>
  </div>
</ng-container>
